import { AutoMap } from '@automapper/classes';

export class MaterielEauEntity {
    Id?: number;
    @AutoMap()
    Type!: number;
    @AutoMap()
    Reference!: string;
    @AutoMap()
    NombreDouche!: number;
    @AutoMap()
    DateChangementFiltre!: string;
    @AutoMap()
    LocalisationRejet!: number;
    @AutoMap()
    Materiau!: string;
}
